module.exports = __webpack_public_path__ + "img/15.f2311e82.jpeg";